module.exports = "//cdn.scentbird.com/assets/frontbird-site/images/coffee@2x_f5f7b7.jpg";